import React, {useEffect, useRef} from "react";
import {Grid, Box, Typography, Divider} from "@mui/material";
import {makeStyles} from "@mui/styles";
import StatusCircle from "../../components/statusCircle";

const Servers = ({data}) => {
    const classes = useStyles();
    const containerRef = useRef(null);

    const rows = [[], [], [], []];

    data.forEach((item, index) => {
        rows[index % 4].push(item);
    });

    useEffect(() => {
        const container = containerRef.current;
        if (!container) return;

        const scrollDuration = 19750;
        const totalScrollDistance = container.scrollWidth - container.clientWidth;
        let startTime = null;

        const animateScroll = (currentTime) => {
            if (!startTime) startTime = currentTime;
            const elapsed = currentTime - startTime;

            // Calculate scroll position as a function of elapsed time
            const scrollPosition = (elapsed / scrollDuration) * totalScrollDistance;
            container.scrollLeft = scrollPosition;

            if (elapsed < scrollDuration) {
                requestAnimationFrame(animateScroll); // Continue animation
            }
        };

        // Start the scrolling animation
        requestAnimationFrame(animateScroll);

        return () => cancelAnimationFrame(animateScroll); // Cleanup on component unmount
    }, []);

    return (
        <div ref={containerRef} className={classes.container}>
            {rows.map((row, rowIndex) => (
                <div key={rowIndex} className={classes.row}>
                    {row.map((item, itemIndex) => (
                        <Box key={itemIndex} className={classes.box} style={itemIndex === 0 ? {marginLeft: 0} : {}}>
                            <div className={classes.topRow}>
                                <div className={classes.statusCircle}
                                     style={{backgroundColor: item.up ? "#0eb92b" : "#e6251e"}}/>
                                <div>
                                    <Typography variant="body1"
                                                className={`${classes.serverName} ${classes.textColor}`}>{item.name}</Typography>
                                    <div style={{display: "flex"}}>
                                        <Typography mr={2} variant="body2"
                                                    className={classes.textColor}>{`HDD: ${item.hdd}`}</Typography>
                                        <Typography variant="body2"
                                                    className={classes.textColor}>{`RAM: ${item.latency}`}</Typography>
                                    </div>
                                </div>
                            </div>
                            <Divider/>
                            <Grid container py={1} px={2}>
                                <Grid item xs={6} display="flex" alignItems="center" className={classes.marginBottom4}>
                                    <Typography variant="body2"
                                                className={classes.textColor}>Webserver</Typography>
                                    <StatusCircle color={!!item.webServerStatus ? "#0eb92b" : "#e6251e"}/>
                                </Grid>
                                <Grid item xs={6} pl={1} className={classes.marginBottom4}>
                                    <Typography variant="body2"
                                                className={classes.textColor}>{`Latency: ${item.latency.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}ms`}</Typography>
                                </Grid>
                                <Grid item xs={6} >
                                    <Typography variant="body2"
                                                className={classes.textColor}>{`HDD Threshold: ${item.hddThreshold}`}</Typography>
                                </Grid>
                                <Grid item xs={6} pl={1}>
                                    <Typography variant="body2"
                                                className={classes.textColor}>{`Uptime: ${item.uptime}`}</Typography>
                                </Grid>
                            </Grid>
                            <Divider/>
                            <div className={classes.section}>
                                <div className={`${classes.flexAlignCenter} ${classes.marginBottom4}`}>
                                    <Typography variant="body2"
                                                className={classes.textColor}>{`Database: ${item.databaseName}`}</Typography>
                                    <StatusCircle color={!!item.databaseStatus ? "#0eb92b" : "#e6251e"}/>
                                </div>
                                <Typography variant="body2" className={classes.textColor}>{`DB-processes: ${item.databaseProcesses}`}</Typography>
                            </div>
                        </Box>
                    ))}
                </div>
            ))}
        </div>
    )
}

const useStyles = makeStyles(() => ({
    container: {
        overflowX: "scroll",
        whiteSpace: "nowrap",
        marginRight: 30,
        marginLeft: 30,
        scrollbarWidth: "none", // Hides scrollbar in Firefox
        "&::-webkit-scrollbar": {
            display: "none" // Hides scrollbar in Chrome, Safari, and Edge
        }
    },
    row: {
        display: "flex",
        marginBottom: 8,
    },
    box: {
        backgroundColor: "#f7ece8",
        borderRadius: "27px",
        marginLeft: 30,
        flexShrink: 0,
        width: 320
    },
    topRow: {
        display: "flex",
        alignItems: "center",
        padding: "8px 16px"
    },
    statusCircle: {
        borderRadius: "50%",
        width: 50,
        height: 50,
        content: "''",
        marginRight: 16
    },
    serverName: {
        fontWeight: "800 !important",
    },
    textColor: {
        color: "#707070"
    },
    flexAlignCenter: {
        display: "flex",
        alignItems: "center"
    },
    section: {
        padding: "8px 16px"
    },
    marginBottom4: {
        marginBottom: "4px !important"
    }
}));


export default Servers;